import { Injectable } from '@angular/core';

import { map, Observable, of } from 'rxjs';

import { Grade } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';
import { observableInSeparateThread } from '../helper/observable-helper';

/**
 * Service to get grades
 */
@Injectable()
export class GradeService {
    private cachedGrades: Grade[] = null;

    /**
     * Constructor
     */
    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Get all grades
     */
    public getIndex(forceRefresh: boolean = false): Observable<Grade[]> {
        if (!forceRefresh &&
            this.cachedGrades) {
            // if `cachedGrades` is available just return it as `Observable`
            return observableInSeparateThread(this.cachedGrades);
        }
        // Make the http request
        const apiUrl: string = `${this.http.configService.getApiBaseUrl()}/grades/`;

        return this.http.get(apiUrl)
            .pipe(map((response: IJsonApiResponse) => {
                const grades: Grade[] = [];
                const bodyData: any = response.data || [];
                for (const grade of bodyData) {
                    grades.push((new Grade()).deserialize(grade));
                }
                this.cachedGrades = grades;
                return this.cachedGrades;
            }));
    }
}
